import React from 'react';
import {
  Box,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Divider,
  Button,
  CircularProgress,
  Alert
} from '@mui/material';
import {
  AdminPanelSettings as AdminIcon
} from '@mui/icons-material';
import { formatDate } from '../../utils/dateUtils';

/**
 * Composant pour gérer les demandes d'administrateurs
 */
const AdminRequests = ({ 
  adminRequests, 
  loading, 
  error, 
  successMessage, 
  openPositionDialog, 
  rejectAdminRequest 
}) => {
  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 3, color: '#014527', fontWeight: 'bold' }}>
        Demandes d'administrateurs
      </Typography>
      
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {successMessage && <Alert severity="success" sx={{ mb: 2 }}>{successMessage}</Alert>}
      
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        <Paper sx={{ 
          p: 3, 
          borderRadius: '10px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)'
        }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Demandes en attente
          </Typography>
          
          {adminRequests.length > 0 ? (
            <List>
              {adminRequests.map((request, index) => (
                <React.Fragment key={request.id}>
                  <ListItem
                    secondaryAction={
                      <Box>
                        <Button 
                          variant="contained" 
                          color="success" 
                          size="small"
                          onClick={() => openPositionDialog(request)}
                          sx={{ mr: 1 }}
                          disabled={loading}
                        >
                          Approuver
                        </Button>
                        <Button 
                          variant="contained" 
                          color="error" 
                          size="small"
                          onClick={() => rejectAdminRequest(request.id)}
                          disabled={loading}
                        >
                          Rejeter
                        </Button>
                      </Box>
                    }
                  >
                    <ListItemIcon>
                      <AdminIcon sx={{ color: '#2563eb' }} />
                    </ListItemIcon>
                    <ListItemText 
                      primary={request.name} 
                      secondary={
                        <>
                          <Typography component="span" variant="body2">
                            Email: {request.email}
                          </Typography>
                          <br />
                          <Typography component="span" variant="body2" color="text.secondary">
                              Demande soumise le: {formatDate(request.createdAt)}
                          </Typography>
                        </>
                      }
                    />
                  </ListItem>
                  {index < adminRequests.length - 1 && <Divider />}
                </React.Fragment>
              ))}
            </List>
          ) : (
            <Typography variant="body1" sx={{ textAlign: 'center', py: 3 }}>
              Aucune demande d'administrateur en attente.
            </Typography>
          )}
        </Paper>
      )}
    </Box>
  );
};

export default AdminRequests;